import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import InfiniteScroll from "./InfiniteScroll/index";

import RecommendedPosts from "./RecommendedPosts";

import { loadPost, loadPopularPost } from "redux/modules/postSlice";

import { DetailLine, Boldline } from "../common/commonStyle";
import {
  FlexCommunityDiv,
  CategoryList,
  CategoryDiv,
  FloatingDiv,
  NoPost,
  H2,
} from "./CommunityPostsStyle";

function CommunityPosts() {
  const dispatch = useDispatch();
  const [currentCategory, setCurrentCategory] = useState("전체");
  const [postsList, setPostsList] = useState([]); // 카테고리별 게시글 리스트
  const [totalLength, setTotalLength] = useState(0); // 카테고리별 총 개수

  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지-1부터시작
  const currentPageFunc = () => {
    setCurrentPage((prev) => prev + 1);
  };
  const setPostsListFunc = (data) => {
    setPostsList((prev) => [...prev, ...data]);
  };

  const { categoryArray } = useSelector((state) => state.post);

  // 포스트 첫 로드
  useEffect(() => {
    const payload = { category: currentCategory, page: currentPage };
    dispatch(loadPost(payload))
      .unwrap()
      .then((res) => {
        res.success && setPostsList(res.data);
        setTotalLength(res.boardCount);
      });
  }, [dispatch, currentCategory]);

  useEffect(() => {
    dispatch(loadPopularPost());
  }, [dispatch]);

  const onClickCategory = useCallback((el) => {
    setPostsList([]);
    setTotalLength(0);
    setCurrentPage(1);
    setCurrentCategory(el);
  }, []);

  return (
    <>
      {/* 카테고리 목록 */}
      <FlexCommunityDiv>
        <CategoryList>
          {categoryArray.map((el, i) => {
            return currentCategory === el ? (
              <CategoryDiv
                className="select"
                key={el}
                onClick={() => onClickCategory(el)}
              >
                <div>{el}</div>
              </CategoryDiv>
            ) : (
              <CategoryDiv key={el} onClick={() => onClickCategory(el)}>
                <div>{el}</div>
              </CategoryDiv>
            );
          })}
        </CategoryList>
      </FlexCommunityDiv>
      <DetailLine />
      {/* 인기게시글 */}
      <H2>인기 게시글</H2>
      <RecommendedPosts
        currentCategory={currentCategory}
        currentPage={currentPage}
      />
      <Link to="/boards/createpost">
        <FloatingDiv>
          <img src="/img/writing.svg" alt="writing button" />
        </FloatingDiv>
      </Link>

      <Boldline />

      {/* 게시글 */}
      {postsList.length > 0 ? (
        <>
          <InfiniteScroll
            currentPage={currentPage}
            currentPageFunc={currentPageFunc}
            currentCategory={currentCategory}
            postsList={postsList}
            totalLength={totalLength}
            setPostsListFunc={setPostsListFunc}
          />
        </>
      ) : currentCategory === "전체" ? (
        <NoPost>게시글이 아직 없습니다.</NoPost>
      ) : (
        <NoPost>해당 카테고리의 게시글이 아직 없습니다.</NoPost>
      )}
    </>
  );
}
export default CommunityPosts;
